import { AuthenticationContext, IAuthenticationInfo } from "helpers/context/Authentication/AuthenticationContext";
import React from "react";

export default function useAuthInfo():IAuthenticationInfo {
    return React.useContext(AuthenticationContext);
}